import React, { useState } from 'react';
import { Badge, IconButton, Popover, Box, Typography, Button } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import MessageIcon from '@mui/icons-material/Message';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaShoppingCart } from 'react-icons/fa';
import notificationService from '../../../../services/notificationService';
import { useSelector } from 'react-redux';
import { use } from 'react';

const NotificationItem = styled(Box)(({ isRead, isOrder }) => ({
    padding: '12px 16px',
    borderBottom: '1px solid #eee',
    '&:last-child': {
        borderBottom: 'none',
    },
    '&:hover': {
        backgroundColor: '#f5f5f5',
    },
    cursor: 'pointer',
    opacity: isRead ? 0.7 : 1,
    backgroundColor: isRead ? '#fafafa' : '#fff',
    background: isRead ? '#fafafa' :
        isOrder
            ? 'linear-gradient(to right, rgba(255, 243, 224, 0.6), rgba(255, 243, 224, 0))'
            : 'linear-gradient(to right, rgba(230, 240, 255, 0.4), rgba(230, 240, 255, 0))',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    transition: 'all 0.3s ease'
}));

const NotificationContent = styled(Box)({
    flex: 1,
});

const NotificationIcon = styled(Box)(({ isRead, isOrder }) => ({
    color: isRead ? '#999' : (isOrder ? '#fb8c00' : '#2196f3'),
    display: 'flex',
    alignItems: 'center',
    '& svg': {
        fontSize: '20px',
    },
    transition: 'color 0.3s ease'
}));

const NotificationTitle = styled(Typography)(({ isRead, isOrder }) => ({
    fontWeight: isRead ? '500' : '600',
    fontSize: '14px',
    color: isRead ? '#666' : (isOrder ? '#f57c00' : '#1976d2'),
}));

const NotificationDescription = styled(Typography)({
    fontSize: '13px',
    color: '#666',
    marginTop: '4px',
});

const MarkAllButton = styled(Button)({
    width: '100%',
    justifyContent: 'center',
    padding: '8px',
    color: '#666',
    fontSize: '13px',
    textTransform: 'none',
    borderTop: '1px solid #eee',
    borderRadius: 0,
    '&:hover': {
        backgroundColor: '#f5f5f5',
    },
});
const NotificationDate = styled(Typography)({
    fontSize: '12px',
    color: '#999',
    marginTop: '4px',
    alignSelf: 'flex-end',
});
const NotificationDropdown = ({ notifications, getNotification }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleNotificationClick = async (notification) => {
        try {
            const data = {
                userId: userId,
                id: notification.id

            }
            await notificationService.readedNotification(data);
            if (notification.contentType === 1) {
                navigate('/orders');
            } else if (notification.contentType === 2) {
                navigate('/questions');
            }
            else if (notification.contentType === 3) {
                navigate('/user-tasks');
            }
            getNotification();
            handleClose();
        } catch (exx) {

        }

    };

    const unreadCount = notifications?.filter(
        (notification) => notification.displayType === 1
    ).length;
    const formattedBadgeContent = unreadCount > 15 ? '15+' : unreadCount;
    const open = Boolean(anchorEl);
    const userId = useSelector(state => state?.auth?.user?.id);
    const handleMarkAllAsRead = async () => {

        try {
            await notificationService.readedAllNotification(userId);
            getNotification();
            handleClose();
        } catch (exx) {

        }

    };


    const goNotifications = async () => {

        try {
            navigate('/Notification');
            handleClose();
        } catch (exx) {

        }

    };
    return (
        <>
            <IconButton
                color="inherit"
                onClick={handleClick}
                sx={{ color: '#696B6C', '&:hover': { color: 'black' } }}
            >
                <Badge badgeContent={formattedBadgeContent} color="error" sx={{ '& .MuiBadge-badge': { fontSize: '10px' } }}>
                    <NotificationsIcon />
                </Badge>
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: {
                        width: '300px',
                        maxHeight: '500px',
                        overflow: 'auto',
                        mt: 1,
                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    },
                }}
            >
                <Box sx={{ maxHeight: '350px', overflow: 'auto' }}>
                    {notifications?.length > 0 ? (
                        notifications.map((notification) => (
                            <NotificationItem
                                key={notification.id}
                                isRead={notification.displayType === 2}
                                isOrder={notification.contentType === 1}
                                onClick={() => handleNotificationClick(notification)}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <NotificationIcon
                                        isRead={notification.displayType === 2}
                                        isOrder={notification.contentType === 1}
                                    >
                                        {notification.contentType === 1 ? (
                                            <FaShoppingCart />
                                        ) : notification.contentType === 3 ? (
                                            <FaCheckCircle />
                                        ) : (
                                            <MessageIcon />
                                        )}
                                    </NotificationIcon>
                                    <NotificationContent>
                                        <NotificationTitle
                                            isRead={notification.displayType === 2}
                                            isOrder={notification.contentType === 1}
                                        >
                                            {notification.title}
                                        </NotificationTitle>
                                        <NotificationDescription>
                                            {notification.description}
                                        </NotificationDescription>
                                        <Typography
                                            sx={{ fontSize: '12px', color: '#888', marginTop: '4px' }}
                                        >
                                            {new Date(notification.createDate).toLocaleString()}
                                        </Typography>
                                    </NotificationContent>
                                </Box>
                            </NotificationItem>

                        ))
                    ) : (
                        <Box p={2} textAlign="center">
                            <Typography color="textSecondary">
                                Bildirim bulunmamaktadır
                            </Typography>
                        </Box>
                    )}
                </Box>

                {notifications?.length > 0 && (
                    <MarkAllButton
                        startIcon={<DoneAllIcon sx={{ fontSize: 16 }} />}
                        onClick={handleMarkAllAsRead}
                    >
                        Tümünü okundu işaretle
                    </MarkAllButton>
                )}
                {notifications?.length > 0 && (
                    <MarkAllButton
                        startIcon={<NotificationsIcon sx={{ fontSize: 16 }} />}
                        onClick={goNotifications}
                    >
                        Tüm bildirimler
                    </MarkAllButton>
                )}
            </Popover>
        </>
    );
};

export default NotificationDropdown;